import { HeaderHttpService } from './../../../service/http/http.service';
import { Injectable } from '@angular/core';
import { Subscription, tap, finalize, BehaviorSubject } from 'rxjs';

export interface CompanyAdmin {
  id: string;
  name: string;
  email: string;
  country: string;
}

@Injectable()
export class CompanyAdminSupportService {
  loaded$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  companyAdmins$: BehaviorSubject<CompanyAdmin[]> = new BehaviorSubject(null);
  selectedAdminsEmails$: BehaviorSubject<string[]> = new BehaviorSubject(null);
  copiedEmail$: BehaviorSubject<string> = new BehaviorSubject(null);

  private subscriptions = new Subscription();

  constructor(private headerHttpService: HeaderHttpService) {}

  init() {
    this.getComapnyAdmins();
  }

  destroy() {
    this.subscriptions.unsubscribe();
  }

  copySelectedEmails() {
    this.setCopiedEmail(null);
    const emailsToCopy = this.selectedAdminsEmails.join(', ');
    navigator.clipboard.writeText(emailsToCopy);
  }

  unselectCompanyAdminsEmails() {
    this.selectedAdminsEmails$.next(null);
  }

  selectCompanyAdminsEmails() {
    const allAdminsEmails = this.companyAdmins$.value.map((admin) => admin.email);
    this.selectedAdminsEmails$.next(allAdminsEmails);
  }

  setCopiedEmail(email: string) {
    this.copiedEmail$.next(email);
  }

  selectUser(id: string) {
    const selectedAdmins = this.selectedAdminsEmails ? this.selectedAdminsEmails : [];
    selectedAdmins.push(id);
    this.selectedAdminsEmails$.next(selectedAdmins);
  }

  unselectUser(email: string) {
    const newSelectedAdmins = this.selectedAdminsEmails.filter((adminEmail) => adminEmail !== email);
    this.selectedAdminsEmails$.next(newSelectedAdmins);
  }

  get selectedAdminsEmails() {
    return this.selectedAdminsEmails$.value;
  }

  get allCompanyAdminsSelected() {
    const selectedLength = this.selectedAdminsEmails?.length;
    return selectedLength > 0 && selectedLength === this.companyAdmins$.value.length;
  }

  private setLoaded(loaded: boolean) {
    this.loaded$.next(loaded);
  }

  private setCompanyAdmins(companyAdmins: CompanyAdmin[]) {
    this.companyAdmins$.next(companyAdmins);
  }

  private getComapnyAdmins() {
    this.subscriptions.add(
      this.headerHttpService
        .getComapnyAdminsHttp()
        .pipe(
          tap((data) => this.setCompanyAdmins(data)),
          finalize(() => this.setLoaded(true)),
        )
        .subscribe(),
    );
  }
}
